import { Box, Grid } from '@mui/material';
import DynamicInputField from 'components/DynamicInputField';
import { showField, showFieldNew } from 'utils/form';
import { Field, FormType, InputType } from 'generated/graphql';

const FormField = ({
  hasWhiteFields = false,
  field,
  autoFocus,
  fieldGroup = [],
  allFields,
  fieldIndex = 0,
  onChange,
  disabled = false,
  isHorizontal = false,
  isQCStorage = false,
  formType,
  onRefresh,
  onFormRefresh,
}: {
  hasWhiteFields?: boolean;
  field: Field;
  autoFocus: boolean;
  fieldGroup?: Field[];
  allFields: Field[];
  fieldIndex?: number;
  disabled?: boolean;
  isHorizontal?: boolean;
  onChange: (fieldGroup: Field[], field: Field, value: string, values?: string[], entityID?: string) => Promise<void>;
  isQCStorage?: boolean;
  formType: FormType;
  onRefresh?: () => void;
  onFormRefresh?: () => void;
}) => {
  if (
    !showFieldNew(field, allFields) || // TODO: Move to showFieldNew once BE moves initial showIf logic to showIfs logic
    !showField(field, allFields) ||
    field.type === InputType.Hidden
  ) {
    return null;
  }
  const input = (
    <DynamicInputField
      key={field.id}
      hasWhiteFields={hasWhiteFields}
      field={field}
      disabled={disabled}
      fieldGroup={fieldGroup}
      allFields={allFields}
      fieldIndex={fieldIndex}
      autoFocus={autoFocus}
      onChange={(value, values, entityID) => onChange(fieldGroup, field, value, values, entityID)}
      isHorizontal={isHorizontal}
      isQCStorage={isQCStorage}
      formType={formType}
      onRefresh={onRefresh}
      onFormRefresh={onFormRefresh}
    />
  );
  if (field.size) {
    // urql adds __typename to every object, and MUI would read it as a breakpoint.
    const { __typename, ...size } = field.size;
    return (
      <Grid size={size} sx={{ mb: 1, alignContent: 'center' }}>
        {input}
      </Grid>
    );
  }
  return (
    <Box
      sx={{
        mb: 1,
        flex: [InputType.Images, InputType.Files, InputType.ButtonUrl, InputType.Numberstepper].includes(field.type)
          ? 'none'
          : 1,
        alignContent: 'center',
      }}
    >
      {input}
    </Box>
  );
};

export default FormField;
